import { FC } from 'react';

/** @deprecated */
const ChartIcon: FC = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M23.5 23.5H0.5V0.5" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 16.5C9 17.329 8.329 18 7.5 18C6.672 18 6 17.329 6 16.5C6 15.672 6.672 15 7.5 15C8.329 15 9 15.672 9 16.5V16.5Z"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.916 8.31449L20.992 3.10849"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.93262 7.46191L14.5506 9.10991"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M0.5 11.7812L7.219 7.77621"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.2988 15.752L20.7038 13.256"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M9 16.5H13.5" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M0.5 21L6.212 17.266" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 7C10 7.829 9.328 8.5 8.5 8.5C7.672 8.5 7 7.829 7 7C7 6.171 7.672 5.5 8.5 5.5C9.328 5.5 10 6.171 10 7V7Z"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.5 9.5C17.5 10.329 16.828 11 16 11C15.172 11 14.5 10.329 14.5 9.5C14.5 8.671 15.172 8 16 8C16.828 8 17.5 8.671 17.5 9.5V9.5Z"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.5 2C23.5 2.829 22.828 3.5 22 3.5C21.172 3.5 20.5 2.829 20.5 2C20.5 1.171 21.172 0.5 22 0.5C22.828 0.5 23.5 1.171 23.5 2V2Z"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.5 12.5C23.5 13.329 22.828 14 22 14C21.172 14 20.5 13.329 20.5 12.5C20.5 11.671 21.172 11 22 11C22.828 11 23.5 11.671 23.5 12.5V12.5Z"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      opacity="0.1"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.5 16.5C16.5 17.329 15.828 18 15 18C14.172 18 13.5 17.329 13.5 16.5C13.5 15.671 14.172 15 15 15C15.828 15 16.5 15.671 16.5 16.5V16.5Z"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ChartIcon;
